import { render } from "./AddFeedType.vue?vue&type=template&id=0d5e8ebe"
import script from "./AddFeedType.vue?vue&type=script&lang=js"
export * from "./AddFeedType.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__